const lang = {
  specifiedCommodityTransactionLaw: '特定商品取引法に基づく表記',
  useAfterUnderstanding: '株式会社ルクレは、お客様が安心してお買い物をしていただけるよう特定商取引に関する法律第11条に基づき、以下に明示します。ご理解の上、ご利用をお願いします。',
  distributor: '販売業者',
  companyName: '株式会社ルクレ',
  operationManager: '運営責任者',
  operationManagerName: '有馬 弘進',
  location: '所在地',
  address: '〒107-0061&emsp;東京都港区北青山1-2-3 青山ビル3F',
  requiredChargeOtherThanUsageFee: '利用代金以外の必要料金',
  willBeIncurredWhenBrowsingOrDownloadingContent: 'サイトの閲覧、コンテンツのダウンロード時などに、利用者様環境でのネットワーク通信料が発生致します。',
  howToOrder: '注文方法',
  fillNecessaryInformationAndSend: '注文フォームに必要事項をご記入頂き送信していただきます。',
  paymentMethod: '支払方法',
  creditCardPayment: 'クレジットカード決済',
  creditCardType: '（VISA・MASTER・JCB、お支払い回数は一回です）',
  paymentPeriod: '支払時期：ご利用のカード会社ごとに異なります。',
  deliveryTime: '商品の引渡時期',
  canUseAfterCompleting: 'お申し込み完了時よりご利用いただけます。',
  exchangeAndReturn: '交換・返品',
  notAcceptedExchangeAndReturn: 'サービスの性質上、解約及び返金はお受けしておりません。',
  shopNameOrServiceName: '屋号またはサービス名',
  serviceName: 'ZENGO',
  phoneNumber: '電話番号',
  phoneNumberContent: '03-4500-6700',
  mailAddress: 'メールアドレス',
  mailContent: 'zengo-support@lecre.jp',
  bankTransfer: '銀行振込',
  dueDatePayment: '支払期限',
  issuanceDate: '当社請求書発行日より',
  businessDay: '７営業日以内',
  paymentConfirm: 'ご入金確認後３~１０営業日以内'
}

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/specifiedCommodityTransactionLaw.js